// Gasto compartido: la parte que paga otra persona queda en Me Deben (no mueve dinero).
import { supabase } from '../supabaseClient';
import { formatCLP } from './format';
import { q } from './vinculos';

export const PORCENTAJES_COMPARTIDO = [50, 25, 33, 66, 75, 100];

// Recuerda con quién se comparten los gastos para no escribirlo cada vez.
const CLAVE_PERSONA = 'gastoCompartidoCon';

export function personaCompartidaGuardada() {
  try { return localStorage.getItem(CLAVE_PERSONA) || ''; } catch { return ''; }
}

function guardarPersonaCompartida(persona) {
  try { localStorage.setItem(CLAVE_PERSONA, persona); } catch { /* sin almacenamiento */ }
}

// Parte del gasto que le corresponde a la otra persona.
export const parteCompartida = (monto, pct) => Math.round((Number(monto) || 0) * (Number(pct) || 0) / 100);

// Valida y devuelve un mensaje de error, o '' si está bien.
export function validarCompartido({ persona, monto, pct }) {
  if (!persona.trim()) return 'Escribe con quién compartes este gasto.';
  const parte = parteCompartida(monto, pct);
  if (parte <= 0 || parte > Number(monto)) return 'El porcentaje compartido debe estar entre 1 y 100.';
  return '';
}

export async function registrarParteCompartida({ userId, persona, pct, monto, fecha, descripcion }) {
  const nombre = persona.trim();
  await q(supabase.from('prestamos').insert({
    user_id: userId,
    persona: nombre,
    monto: parteCompartida(monto, pct),
    fecha_prestamo: fecha,
    notas: `${pct}% de: ${descripcion || 'gasto compartido'} (${formatCLP(monto)})`,
    cobrado: false,
  }));
  guardarPersonaCompartida(nombre);
}

// Personas a las que ya se les prestó (para sugerirlas al escribir).
export async function personasConocidas(userId) {
  const filas = await q(supabase.from('prestamos').select('persona').eq('user_id', userId));
  return [...new Set((filas || []).map(p => p.persona).filter(Boolean))];
}
